import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateRouteGuard } from '@core/guards/can-activate-route.guard';
import { LogGuard } from '@core/guards/log.guard';
import { DashboardService } from '@page/dashboard/helper/dashboard.service';
import { firstValueFrom } from 'rxjs';
import { LayoutComponent } from './layout/layout.component';
import { NotificationService } from '@page/notification/notification.service';
import { LocationRequiredComponent } from '@core/location-required/location-required.component';
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard',

  },
  { path: 'location-required', component: LocationRequiredComponent },
  {
    path: 'icon-list',
    loadComponent: () => import('@core/Icons-details/Icons-details.component').then(c => c.IconsDetailsComponent)
  },
  { path: 'maintenance', loadComponent: () => import('./pages/maintenance/maintenance.component').then(c => c.MaintenanceComponent) },
  {
    path: 'page-not-found',
    loadComponent: () => import('./pages/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
  },

  {
    path: 'auth',
    canActivate: [LogGuard],
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [CanActivateRouteGuard],
    children: [
      {
        path: '',
        resolve: {
          kycStatus: async () => {

            inject(NotificationService).getNotificationCount().subscribe();
            await firstValueFrom(inject(DashboardService).getKycStatus());
            return true;
          }
        },
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule)
      },
      {
        path: '**',
        loadComponent: () => import('src/app/pages/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
      }
    ],
  },

  {
    path: '**',
    redirectTo: '/page-not-found',
  }
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [],
  exports: [RouterModule],
})
export class AppRoutingModule { }
